import { InfraEditForm } from 'app/agriculture/routes/Infra/InfraEdit/components/InfraEditForm';
import { InfraType } from 'app/agriculture/mutations/types/entityConfig';
import { useParams } from 'react-router-dom';
import { NotFound } from 'app/agriculture/routes/NotFound';

interface InfraEditProps {
    infraType: InfraType;
}

export function InfraEdit({ infraType }: InfraEditProps) {
    const { id } = useParams();
    if (id == null) return <NotFound />;

    return <InfraEditForm infraType={infraType} infraId={id} />;
}
